import { Button, Center, Stack, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { useClientsContext } from 'src/clients/context/ClientsContext';

type Props = {
  firstName: string;
};

export function FamilyEmptyState({ firstName }: Props) {
  const { startFamilyCreation } = useClientsContext();

  return (
    <Center py="xxl">
      <Stack align="center" gap="md" maw={480}>
        <Text size="displayXs" fw={FONT_WEIGHTS.semibold} c="gray.10" ta="center">
          Create a family for {firstName}
        </Text>
        <Text size="textMd" c="gray.6" ta="center">
          Link {firstName} with other family members to manage finances together — combine assets,
          generate joint reports, and see the full picture across everyone.
        </Text>
        <Button variant="primary" mt="xs" onClick={startFamilyCreation}>
          Create family
        </Button>
      </Stack>
    </Center>
  );
}
